var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditPencilBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3777_132)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 1,
    width: 36,
    height: 36,
    rx: 4,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2.5,
    y: 1.5,
    width: 35,
    height: 35,
    rx: 3.5,
    stroke: "#D2D2D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7586 14.7321L24.268 11.2407C24.1519 11.1246 24.0141 11.0325 23.8624 10.9697C23.7107 10.9069 23.5482 10.8745 23.384 10.8745C23.2198 10.8745 23.0572 10.9069 22.9056 10.9697C22.7539 11.0325 22.6161 11.1246 22.5 11.2407L12.8664 20.8751C12.7498 20.9908 12.6574 21.1284 12.5945 21.2801C12.5316 21.4318 12.4995 21.5945 12.5 21.7587V25.2501C12.5 25.5816 12.6317 25.8996 12.8661 26.134C13.1005 26.3684 13.4185 26.5001 13.75 26.5001H17.2414C17.4056 26.5006 17.5683 26.4685 17.72 26.4056C17.8717 26.3427 18.0094 26.2503 18.125 26.1337L27.7586 16.5001C27.8747 16.384 27.9668 16.2462 28.0296 16.0945C28.0925 15.9429 28.1248 15.7803 28.1248 15.6161C28.1248 15.4519 28.0925 15.2894 28.0296 15.1377C27.9668 14.986 27.8747 14.8482 27.7586 14.7321ZM17.2414 25.2501H13.75V21.7587L20.625 14.8837L24.1164 18.3751L17.2414 25.2501ZM25 17.4907L21.5086 14.0001L23.3836 12.1251L26.875 15.6157L25 17.4907Z",
    fill: "#393939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3777_132",
    x: 0,
    y: 0,
    width: 40,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3777_132"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3777_132",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditPencilBox);
export default __webpack_public_path__ + "static/media/edit-pencil-box.172bfdbd109db686fba85ef36763f239.svg";
export { ForwardRef as ReactComponent };